import React from 'react';
import AuthInfo from '../molecules/AuthInfo';
import { Button } from '../buttons';

const SignUpForm = (props) => (
  <div>
    <p>Selamat datang kembali! Yuk kirim barang lagi</p>
    <div className="form-group">
      <input
        type="text"
        onChange={props.handleChange('email')}
        placeholder="Email"
        className="form-control"
        values={props.values.email}
        />
    </div>

    <div className="form-group">
      <input
        type="password"
        onChange={props.handleChange('password')}
        placeholder="Password"
        className="form-control"
        values={props.values.password}
        />
    </div>
    <Button
      onClick={props.onSubmit}
      loading={props.loading}
      className="btn btn-primary btn-block"
      >
      {props.loading ? "Submitting..." : "Submit"}
    </Button>
    <AuthInfo />
  </div>
)


export default SignUpForm
